// extracted by mini-css-extract-plugin
module.exports = {"quoteSlider":"quote-slider_quoteSlider___FY9M","largeMode":"quote-slider_largeMode__ttXKC","dark":"quote-slider_dark__rSyVa"};